import React, { ReactNode } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListItemIcon from '@mui/material/ListItemIcon';
import cn from 'clsx';
import styles from '@components-clean/page-nav/page-nav-menu-item.module.scss';

interface PageNavMenuItemIconProps {
    className?: string;
    icon?: ReactNode;
    faIcon?: IconDefinition | IconProp;
    isCollapsed: boolean;
}

const PageNavMenuItemIcon = ({ className, icon, faIcon, isCollapsed }: PageNavMenuItemIconProps) => {
    return (
        <ListItemIcon className={cn(isCollapsed ? styles.collapsedMenuListItemIcon : styles.listItemIcon, className)}>
            {faIcon && (
                <FontAwesomeIcon
                    icon={faIcon}
                    className={isCollapsed ? styles.collapsedMenuNavigationItem : styles.navigationItem}
                />
            )}
            {icon && icon}
        </ListItemIcon>
    );
};

export default PageNavMenuItemIcon;
